import VueSimpleSpinner from "vue-simple-spinner";
import {BallPulseLoader} from "vue-loaders";
import FacilityControl from "@/componentsReusable/FacilityControl.vue";
import StateControl from "@/componentsReusable/StateControl.vue";
import CustomDropdownControl from "@/componentsReusable/CustomDropdownControl.vue";
import flatPickr from "vue-flatpickr-component";
import ButtomToggleControl from "@/componentsReusable/ButtonToggleControl.vue";
import MaskedInput from "vue-text-mask";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
  name: 'ProviderAdvancedSearchFields',
  components: {
    VueSimpleSpinner,
    BallPulseLoader,
    FacilityControl,
    StateControl,
    CustomDropdownControl,
    flatPickr,
    ButtomToggleControl,
    MaskedInput
  },
  filters: {
    state (state: any) {
      return state.stateFull + ", " + state.stateAbbrev;
    },
  }
})
export default class ProviderAdvancedSearchFields extends Vue {
  @Prop({ type: Object, required: true })
  advancedSearchFilters!: any;

  milesMask = createNumberMask({
    prefix: '',
    allowDecimal: false,
    integerLimit: 4,
    thousandsSeparatorSymbol: ''
  });

  addFilter (filterList: any[], filter: any) {
    if(!filterList.some( ( (filterInstance: any) => filterInstance.id === filter.id ) ) ) {
      filterList.push(filter);
    }
  }

  removeFilter(filtersList: any[], filterId: Number) {
    for (let i=0; i<filtersList.length; i++) {
      if (filtersList[i].id === filterId) {
        filtersList.splice(i,1);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/providers/ProviderAdvancedSearchFields.ts